import { render, staticRenderFns } from "./LahanVerificationFc.vue?vue&type=template&id=2a7345b8"
import script from "./LahanVerificationFc.vue?vue&type=script&lang=js"
export * from "./LahanVerificationFc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports